import React, { useState, useEffect, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Container } from 'reactstrap';
import lodash from 'lodash';
import {
  eCommerceReportBuyFamilyPackage,
  eCommerceReportBuyRegularPackage,
  setLoading,
  removeOtpData,
  closeModal,
  abroadRetrieveCustomerData,
  validateCustomerType,
  validateCustomerFamilyType,
  openModal,
  setOtpPopupData,
  returnToLobby,
  setSaleActiveStep,
  saveNotSupportedCountries,
  saveToHistory,
  saveSelectedStartDate,
  setShadowProcessStage,
  setSelectedAbroadPackage,
  PlantShadowMemo,
  PlantMemoBeforePackagePurchase,
  abroadRetrieveCustomerDataNoEffect,
  abroadRemoveAndAddSocBusinessIndividual,
  setSaleOtpStep,
  setReadyToPurchaseForBusinessIndividualAndSetAllowIndependentFuturePurchases,
  setReadyToPurchase,
  setBuyPackageInSplit,
  setSwitchingAccount,
  displayRestrictedCodePopup,
  resetFamilyBundleData,
  clearPurchasedFamilyBundleData,
  setFamilyBundleErrorType,
  resetCoupon,
  setFlightManager,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import { getPackageEndDate, formatDatesToDifferentFormats } from '../CellcomAbroadLobbyBlock/cellcomAbroadUtilities';
import {
  saleActiveStep,
  lobbyTabsEnum,
  customerTypeEnum,
  otpValidationPopupContent,
  saleOTPSteps,
  popupReasonEnum,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import { isMobile } from 'react-device-detect';
import PlaneLoader from './PlaneLoader';
import AbroadTicketComponent from './AbroadTicketComponent';
import PopUp from '../../Shared/Popup/PopUp';
import OtpValidationResultPopupConstructor from '../CellcomAbroadLobbyBlock/Popups/OtpValidationResultPopupConstructor';
import ChangeStartPackageDatePopup from '../CellcomAbroadLobbyBlock/Popups/ChangeStartPackageDatePopup';
import InfoFamilyPackagePopup from '../CellcomAbroadLobbyBlock/Popups/InfoFamilyPackagePopup';
import DataUsageIsBlockedPopupComponent from '../CellcomAbroadLobbyBlock/Popups/DataUsageIsBlockedPopupComponent';
import AccountSegmentMatchSocPopupComponent from '../CellcomAbroadLobbyBlock/Popups/AccountSegmentMatchSocPopupComponent';
import CompletedSuccessfulComponent from './CompletedSuccessfulComponent';
import CompletedWithErrorComponent from './CompletedWithErrorComponent';
import { getItem } from '../../../utilities/localStorageUtils';
import useExtendedEffect from '../../../utilities/hooks/useExtendedEffect';
import gaParams from '../../../utilities/analytics/constants';
import { gaEvent, gtag4 } from '../../../utilities/analytics/tracking';
import { gAPopupsLoadingReport } from '../CellcomAbroadLobbyBlock/gAPopupsLoadingReport';
import AbroadStateInclude from '../CellcomAbroadLobbyBlock/Shared/Components/AbroadStateInclude';
import useClearStateResetFlag from '../../../utilities/hooks/useClearStateResetFlag';
import { gaOnLoadTicket } from './gaReports';
import './AbroadTicketMain.scss';
import { resetAuth, resetLoginData } from '../../../utilities/authentication/authenticationSlice';
import { dwhThirdPartyConsentCheckboxDisplay } from '../ChangePricePlanBlock/reports/dwhReports';
import IndependentPurchasePermissionPopUp from '../CellcomAbroadLobbyBlock/Popups/IndependentPurchasePermissionPopUp';
import InterestedToBuyFromOrgPopup from '../CellcomAbroadLobbyBlock/Popups/IsInterestedToBuyFromOrg';
import RestrictedCodePopup from 'app/Components/Block/CellcomAbroadLobbyBlock/Popups/RestrictedCodePopup';
import CapSocPopup from 'app/Components/Block/CellcomAbroadLobbyBlock/Popups/CapSocPopup';
import CapSocRemoveProcessPopup from 'app/Components/Block/CellcomAbroadLobbyBlock/Popups/CapSocRemoveProcessPopup';
import AbroadLoaderAnimation from './AbroadLoaderAnimation';
import { abroadRemoveAndAddSoc, abroadRemoveAndAddSocFamily } from '../CellcomAbroadLobbyBlock/Shared/abroadThunk';
import SelectFamilyMembersPopup from './Popups/SelectFamilyMembersPopup';
import NoMembersSelectedPopup from './Popups/NoMembersSelectedPopup';
import FamilyBundleInfoPopup from './Popups/FamilyBundleInfoPopup';
import FamilyBundleErrorPopup from '../CellcomAbroadLobbyBlock/Popups/FamilyBundleErrorPopup';
import { setSelfcareSubscriber } from '../../Page/SelfCarePage/SelfCareSlice';

function AbroadTicketMain(props) {
  if (!props.data.selectedAbroadPackage) {
    let url = '';
    if (props.data.epiStyleInitializationData.currentLobbyPath) {
      if (props.data.epiStyleInitializationData.businessIndividualLobby && !props.data.businessIndividualData.selectedAccountNumber) {
        url = props.data.businessIndividualData.selfCareBlockUrl;
      } else {
        url = props.data.epiStyleInitializationData.currentLobbyPath;
      }
    }

    props.context.navigateTo(url);
  }
  const [phoneObj, setPhoneObj] = useState({});

  console.log(props.iContent)
  //text from epi server field for text on checkbox label
  const checkBoxText = props.iContent.text.value;
  const newTermsUrl = props.iContent.termsUrl.value;
  const dispatch = useDispatch();
  const [CollaborationValue, setCollaborationValue] = useState(false);

  // Ref that always holds the latest errorType — safe to read in stale cleanup closures
  const familyBundleErrorTypeRef = React.useRef(props.data.familyBundleData?.errorType);
  useEffect(() => {
    familyBundleErrorTypeRef.current = props.data.familyBundleData?.errorType;
  }, [props.data.familyBundleData?.errorType]);

  const businessOrPrivate =
    props.data.otpData.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS ||
      props.data.epiStyleInitializationData.businessIndividualLobby
      ? customerTypeEnum.BUSINESS
      : customerTypeEnum.PRIVATE;

  const allowedPopupsReasons = [
    popupReasonEnum.DISPLAY_INFO_FAMILY,
    popupReasonEnum.DISPLAY_INFO_FAMILY_BUNDLE,
    popupReasonEnum.STATE_SUPPORTED,
    popupReasonEnum.OTP_RESULT,
    popupReasonEnum.ERROR_MESSAGE,
    popupReasonEnum.CHANGE_PACKAGE_START_DAY,
    popupReasonEnum.DATA_USAGE_IS_BLOCKED,
    popupReasonEnum.ACCOUNT_SEGMENT_MATCH_SOC,
    popupReasonEnum.ENABLE_INDEPENDENT_PURCHASE,
    popupReasonEnum.BUY_WITH_ORG_TICKET,
    popupReasonEnum.RESTRICTED_CODE_REQUIRED,
    popupReasonEnum.CAP_SOC,
    popupReasonEnum.CAP_SOC_REMOVE_PROCESSING,
    popupReasonEnum.SELECT_FAMILY_MEMBERS,
    popupReasonEnum.NO_MEMBERS_SELECTED,
    popupReasonEnum.FAMILY_BUNDLE_FLIGHT_MANAGER_ERROR,
    popupReasonEnum.FAMILY_BUNDLE_FLIGHT_MEMBERS_ERROR,
    popupReasonEnum.FAMILY_BUNDLE_CELLULAR_DATA_OFF,
    popupReasonEnum.FAMILY_BUNDLE_HAS_SOC,
  ];

  useEffect(() => {
    props.resetFamilyBundleData();
    if (props.data.isShowPopup) {
      props.closeModal();
    }
    return () => {
      console.log('[AbroadTicketMain UNMOUNT] errorType ref:', familyBundleErrorTypeRef.current);
      if (familyBundleErrorTypeRef.current !== 'members') {
        props.resetFamilyBundleData();
      }
    };
  }, []);

  //--------- UseEffect ---------
  useExtendedEffect((runSideEffects) => {
    if (props.data.otpData.validatedCostumerData?.isSeparatedSale) {
      props.setSaleActiveStep(saleActiveStep.TICKET);
    }

    if (props.data.otpData?.validatedCostumerData?.isSeparatedSale) {
      let generateText = '';
      if (
        props.data.otpData.validatedCostumerData?.shadowData.ban &&
        props.data.otpData.validatedCostumerData?.shadowData.ban != '0' &&
        props.data.otpData.validatedCostumerData?.shadowData.ban != '-1' &&
        props.data.otpData.validatedCostumerData?.shadowData.status != 'N' &&
        props.data.shadowForm.customerEmail == ''
      ) {
        if (props.data.businessIndividualData.allowIndependentFuturePurchases) {
        } else {
          generateText = 'החיוב ירד מכרטיס אשראי';
        }
      } else {
        if (props.data?.shadowClientBillData?.paymentType) {
          if (props.data?.shadowClientBillData?.paymentType == 'CC' || props.data.shadowUpdatedCC) {
            generateText = 'החיוב ירד מכרטיס אשראי';
          } else {
            if (props.data?.shadowClientBillData?.paymentType == 'Bank') {
              generateText = 'החיוב ירד בהוראת קבע';
            } else {
              generateText = 'לא קיים אמצעי תשלום';
            }
          }
        } else {
          generateText = 'לא קיים אמצעי תשלום';
        }
      }
      gaEvent(gaParams.SEPARATED_TICKETSCREEN_SHOW.category, gaParams.SEPARATED_TICKETSCREEN_SHOW.eventType, generateText);
    }

    if (runSideEffects()) {
      props.saveNotSupportedCountries(null);
      props.setLoading(false);
      props.clearPurchasedFamilyBundleData();
      setImmediate(() => {
        props.saveToHistory();
      });

      gaReportOnLoading();
      if (props.authentication?.loginData?.isOtpAuthenticated || props.authentication?.loginData?.isFullAuthenticated) {
      }
    }

    if (
      props.data.businessIndividualData.buyPackageInSplit == null &&
      !props.data.businessIndividualData?.isFullFinancing &&
      props.data.epiStyleInitializationData.businessIndividualLobby &&
      props.data.businessIndividualData?.isSwitching
    ) {
      props.openModal(popupReasonEnum.BUY_WITH_ORG_TICKET);
    }

    return () => {
      if (!props.data.isFromSuccess) props.setSaleActiveStep(saleActiveStep.TICKET);
      props.setOtpPopupData('');
      props.closeModal();
      console.log('[AbroadTicketMain useExtendedEffect CLEANUP] errorType ref:', familyBundleErrorTypeRef.current);
      if (familyBundleErrorTypeRef.current !== 'members') {
        props.resetFamilyBundleData();
      }
    };
  }, []);

  // login on reset
  useExtendedEffect(
    (runSideEffects) => {
      if (!runSideEffects()) {
        if (props.authentication?.loginData?.isOtpAuthenticated) {
          submitValidateCustomerType(props.authentication.loginData.userDetails.contactNumber);
        } else if ((props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) && props.data.otpDataChildren.saleOTPStep != saleOTPSteps.SELECT_FAMILY_MEMBER) {
          if (getItem('abroadOTP', true)) {
            const savedAccount = getItem('abroadOTP', true);
            submitValidateCustomerType(savedAccount.validatedPhone);
          }
        }
      }
    },
    [props.authentication.loginData],
  );  // dwh
  useEffect(() => {
    if (props.data.otpData.validatedCostumerData.needToSignCollaborationApproval) {
      dwhThirdPartyConsentCheckboxDisplay(
        props.authentication.loginData.userDetails.firstName + ' ' + props.authentication.loginData.userDetails.lastName,
        props.authentication.loginData.userDetails.contactNumber,
        props.authentication.loginData.userDetails.IDNumber,
        `${window.Config.brand_Name_HE} חו/ל`,
      );
    }
  }, [props.data.otpData.validatedCostumerData.needToSignCollaborationApproval, props.authentication.loginData]);

  //---------validate Customer ---------
  console.log(props.data.familyBundleData);

  function submitValidateCustomerType(phone) {
    if (props.data.otpData?.isFamilyProcess) {
      const startDateChildren = formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedProvider;
      const endDateChildren = getPackageEndDate(
        props.data.dates.datePickerStartJSFormat,
        props.data.selectedAbroadPackage?.packageDuration,
      ).formattedProvider;

      let blockId =
        props.data.otpDataChildren.isOTPValidated &&
          props.data.otpDataChildren.validatedCostumerData?.accountType == customerTypeEnum.BUSINESS
          ? props.data.epiStyleInitializationData.businessSocPackageFolderId
          : props.data.epiStyleInitializationData.privateSocPackageFolderId;

      const otpObj = {
        SubscriberNoParent: props.data.otpData.otpPhone, //todo
        SubscriberChildren: phone || props.data.otpDataChildren.otpPhone,

        SocCodeFamilyPackage: props.data.selectedAbroadPackage?.socCode,
        SocCodePackageGiveFamilyBonus: props.data.otpData?.socCodeParent,
        StartDateChildren: startDateChildren,
        EndDateChildren: endDateChildren,
        StartDateParent: props.data.otpData.startDateParent,
        Countries:
          props.data.otpData?.isFamilyProcess && props.data?.fromPackageManagerToTicket
            ? props.data.selectedCountriesFamily.map((x) => x.countryCode)
            : props.data.selectedCountries.map((x) => x.countryCode),
        BlockId: blockId,
      };
      const isFullLogin = props.authentication?.loginData?.isFullAuthenticated;

      if (!isFullLogin) {
        otpObj.OtpTicketChildren = props.data.otpDataChildren.step1Ticket;
      }
      if ((!isFullLogin && otpObj.OtpTicketChildren != '') || isFullLogin) {
        props.validateCustomerFamilyType(otpObj);
      }
    } else {
      const otpObj = {
        phoneNumber: phone || props.data.otpData.otpPhone,
        type: props.data.selectedAbroadPackageFolderType,
      };
      props.validateCustomerType(otpObj).then((res) => {
        //run separated sale validation
        const validatedData = res.payload.response;
        setPhoneObj(validatedData);
        const selectedPackage = props.data.selectedAbroadPackage;
        if (validatedData.isSeparatedSale) {
          props.setLoading(true);
          const sendObj = {
            phoneNumber: phone || props.data.otpData.otpPhone,
            socCode: selectedPackage.socCode,
            startDate: props.data.dates.selectedStartDate,
            endDate: props.data.dates.selectedEndDate,
            type: 'Business',
            blockId: props.data.epiStyleInitializationData.businessSocPackageFolderId,
            countries: lodash.map(props.data.selectedCountries, 'countryCode'),
          };

          props.abroadRetrieveCustomerDataNoEffect(sendObj).then((res) => {
            props.setLoading(false);
            const customerData = res.payload;
            if (customerData?.isDefaultSoc && customerData?.isDefaultSoc.length != 0) {
              props.setOtpPopupData(otpValidationPopupContent.defaultPackageExists);
              props.openModal(popupReasonEnum.OTP_RESULT);

              props.PlantShadowMemo({
                banId: customerData.shadowData?.ban,
                soc: selectedPackage.socCode,
                subscriber: phone || props.data.otpData.otpPhone,
                shadowBan: customerData.shadowData?.ban,
                memoType: '2',
              });
            } else if (customerData?.subsriberSurfIsBlocked && selectedPackage.type.toUpperCase().includes('DATA')) {
              if (selectedPackage.isBankOrByUse == 'ByUse') {
                props.setOtpPopupData(otpValidationPopupContent.abroadIsClosedForAccountSeparatedByUse);
              } else {
                props.setOtpPopupData(otpValidationPopupContent.abroadIsClosedForAccountSeparatedBank);
              }
              props.openModal(popupReasonEnum.OTP_RESULT);

              props.PlantShadowMemo({
                banId: customerData.shadowData?.ban,
                soc: selectedPackage.socCode,
                subscriber: phone || props.data.otpData.otpPhone,
                shadowBan: customerData.shadowData?.ban,
                memoType: '3',
              });
            } else if (customerData?.shadowData?.ban == '-1') {
              props.setOtpPopupData(otpValidationPopupContent.separatedGeneralError);
              props.openModal(popupReasonEnum.OTP_RESULT);

              props.PlantShadowMemo({
                banId: customerData.shadowData?.ban,
                soc: selectedPackage.socCode,
                subscriber: props.data.otpData.otpPhone,
                shadowBan: customerData.shadowData?.ban,
                memoType: '4',
              });
            } else {
              if (!props.PaymentCG?.isTermsAccepted && props.data?.shadowClientBillData == null) {
                props.PlantMemoBeforePackagePurchase({
                  banId: customerData.shadowData.ban,
                  soc: selectedPackage.socCode,
                  subscriber: phone || props.data.otpData.otpPhone,
                  countries: lodash.map(props.data.selectedCountries, 'countryCode'),
                  startDate: props.data.dates.selectedStartDate,
                  endDate: props.data.dates.selectedEndDate,
                });
                props.context.navigateTo(props.data.epiStyleInitializationData.urlToSeparatedSale);
              } else {
                props.setSaleOtpStep(saleOTPSteps.AFTER_INPUT);
              }
            }
          });
        }
      });
    }
  }

  function onChangeCollaboration(value) {
    setCollaborationValue(value);
  }

  const setToBuyInSplit = (val) => {
    props.setBuyPackageInSplit(val);
    props.setSwitchingAccount(false);
    props.closeModal();
  };

  useEffect(() => {
    if (props.data.saleActiveStep === saleActiveStep.COMPLETED_SUCCESSFUL) {
      if (!props.data?.otpData?.isFamilyProcess) props.eCommerceReportBuyRegularPackage();
      else props.eCommerceReportBuyFamilyPackage();
      if (props.data.selectedAbroadPackage?.isFamilyBundle) {
        const fm = props.data.familyBundleData?.flightManager;
        const fmPhone = fm ? (typeof fm === 'string' ? fm : fm.phone || fm.productSubscriberNo || null) : null;
        if (fmPhone) {
          props.setSelfcareSubscriber(fmPhone);
        }
      }
    }
  }, [props.data.saleActiveStep]);

  useEffect(() => {
    return () => {
      props.resetCoupon();
    };
  }, []);

  useEffect(() => {
    if (
      props.data.otpData.readyToPurchase &&
      !props.data.otpData?.isFamilyProcess &&
      !props.data.otpData?.validatedCostumerData?.isSeparatedSale
    ) {
      const startDate = formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedProvider;
      const endDate = getPackageEndDate(props.data.dates.datePickerStartJSFormat, props.data.selectedAbroadPackage?.packageDuration);
      const fm = props.data.familyBundleData?.flightManager;
      const flightManagerPhone = props.data.selectedAbroadPackage?.isFamilyBundle && fm
        ? (typeof fm === 'string' ? fm : fm.phone || fm.productSubscriberNo || null)
        : null;
      const customerData = {
        subscriberNumber: flightManagerPhone || props.data.otpData.otpPhone,
        soc: props.data.selectedAbroadPackage?.socCode,
        startDate: startDate,
        endDate: endDate.formattedProvider,
        countries: lodash.map(props.data.selectedCountries, 'countryCode'),
        blockId: props.data.epiStyleInitializationData.lobbyBlockId, //lobby block id!
        shouldRemoveSurfingBlockage: props.data.removeToCustomerSurfingBlockage,
        type: props.data.otpData.validatedCostumerData?.accountType,
        signCollaborationApproval: CollaborationValue,
        isShelfEpi:
          !props.data.abroadPackagesList?.businessIndividual ||
          (props.data.abroadPackagesList?.businessIndividual && props.data.selectedAbroadPackage.isShelfBusinessIndividual),
      };

      props.abroadRemoveAndAddSoc(customerData);
    }

    if (props.data.otpDataChildren.readyToPurchase && props.data.otpData?.isFamilyProcess) {
      const startDate = formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedProvider;
      const endDate = getPackageEndDate(props.data.dates.datePickerStartJSFormat, props.data.selectedAbroadPackage?.packageDuration);
      const abroadBlockId =
        props.data.epiStyleInitializationData.lobbyBlockId === '' ? props.blockId : props.data.epiStyleInitializationData.lobbyBlockId;

      const customerData = {
        SubscriberNoParent: props.selectedSubscriberPhone || props.data.otpData.otpPhone,
        soc: props.data.selectedAbroadPackage?.socCode,
        startDate: startDate,
        endDate: endDate.formattedProvider,
        countries:
          props.data.otpData?.isFamilyProcess && props.data?.fromPackageManagerToTicket
            ? props.data.selectedCountriesFamily.map((x) => x.countryCode)
            : props.data.selectedCountries.map((x) => x.countryCode),
        blockId: abroadBlockId, //lobby block id!
        shouldRemoveSurfingBlockage: props.data?.otpDataChildren?.removeToCustomerSurfingBlockage
          ? props.data?.otpDataChildren?.removeToCustomerSurfingBlockage
          : false,
        type: props.data.otpData.validatedCostumerData?.accountType,
        //OtpTicketChildren: props.data.otpDataChildren.step1Ticket,
        SubscriberChildren: props.data.otpDataChildren.otpPhone,
        startDateParent: props.data.otpData?.startDateParent,
        socCodePackageGiveFamilyBonus: props.data.otpData?.socCodeParent,
        signCollaborationApproval: CollaborationValue,
      };
      if (!props.authentication?.loginData?.isFullAuthenticated) {
        customerData.OtpTicketChildren = props.data.otpDataChildren.step1Ticket;
      }
      props.abroadRemoveAndAddSocFamily(customerData);
    }
  }, [props.data.otpData.readyToPurchase, props.data.otpDataChildren.readyToPurchase]);

  useEffect(() => {
    if (props.data.businessIndividualData.readyForPurchase) {
      const startDate = formatDatesToDifferentFormats(props.data.dates.datePickerStartJSFormat).formattedProvider;
      const endDate = getPackageEndDate(props.data.dates.datePickerStartJSFormat, props.data.selectedAbroadPackage?.packageDuration);

      const customerData = {
        subscriberNumber: props.data.businessIndividualData.selectedAccountNumber,
        soc: props.data.selectedAbroadPackage?.socCode,
        startDate: startDate,
        endDate: endDate.formattedProvider,
        countries: lodash.map(props.data.selectedCountries, 'countryCode'),
        shouldRemoveSurfingBlockage: props.data.removeToCustomerSurfingBlockage,
        type: customerTypeEnum.BUSINESS,
        orgId: props.portalsBlock.privateCompanyList.find((org) => org.idNumber == props.portalsBlock.selectedHetPay).orgId,
        blockId: props.data.epiStyleInitializationData.businessSocPackageFolderId, //in case of conflict (check shadow soc)
        isShelf: props.data.selectedAbroadPackage?.isShelfBusinessIndividual,
        signCollaborationApproval: CollaborationValue,
        allowIndependentFuturePurchases: props.data.businessIndividualData.allowIndependentFuturePurchases,
        isSplitBuy: props.data.businessIndividualData.buyPackageInSplit,
        packageType: props.data.selectedAbroadPackage?.type,
      };

      props.abroadRemoveAndAddSocBusinessIndividual(customerData);
    }
  }, [props.data.businessIndividualData.readyForPurchase]);

  //GA REPORT POPUPS
  useEffect(() => {
    if (
      props.data.popupReason &&
      (props.data.otpData.otpPopupData?.id ||
        (props.data.epiStyleInitializationData.businessIndividualLobby && props.data.businessIndividualData.popupData?.id))
    ) {
      let errorType = '';

      if (props.data.popupReason == popupReasonEnum.OTP_RESULT) {
        errorType = props.data.epiStyleInitializationData.businessIndividualLobby
          ? props.data.businessIndividualData.popupData.id
          : props.data.otpData.otpPopupData.id;
      }

      gAPopupsLoadingReport({
        popupReason: props.data.popupReason,
        errorType: errorType,
        startedFromPackage: props.data.startedFromPackage,
        businessOrPrivate: businessOrPrivate,
        comingFromPackageManager: props?.data?.comingFromPackageManager,
        isFamilyProcess: props?.data?.otpData?.isFamilyProcess,
        isSeparatedSale: props?.data?.otpData?.validatedCostumerData?.isSeparatedSale,
        isBusinessIndividual: props.data.epiStyleInitializationData.businessIndividualLobby,
        selectedPackage: props.data.selectedAbroadPackage,
      });
    }
  }, [props.data.popupReason]);

  useClearStateResetFlag();

  //CURRENT STEP
  function renderedStep() {
    switch (props.data.saleActiveStep) {
      case saleActiveStep.TICKET:
        return (
          <AbroadTicketComponent
            context={props.context}
            //text from epi server field for text on checkbox label
            checkBoxText={checkBoxText}
            newTermsUrl={newTermsUrl}
            NeedToSignCollaborationApproval={props.data.otpData.validatedCostumerData.needToSignCollaborationApproval}
            businessOrPrivate={businessOrPrivate}
            submitValidateCustomerType={submitValidateCustomerType}
            onChangeCollaboration={onChangeCollaboration}
          />
        );
      case saleActiveStep.LOADER:
        if (props?.data?.isRegularAbroadCustomer) {
          return <AbroadLoaderAnimation />;
        }
        return <PlaneLoader text={'מחממים מנועים'} animated={false} />;

      case saleActiveStep.COMPLETED_SUCCESSFUL:
        console.log('[AbroadTicketMain COMPLETED_SUCCESSFUL] isRegularAbroadCustomer:', props?.data?.isRegularAbroadCustomer, '| isSeparatedSale:', props.data.otpData.validatedCostumerData?.isSeparatedSale, '| familyBundleData.errorType:', props.data.familyBundleData?.errorType, '| familyBundleData.failedMembers:', props.data.familyBundleData?.failedMembers);
        if (
          (props?.data?.isRegularAbroadCustomer && !props.data.otpData.validatedCostumerData?.isSeparatedSale) ||
          props.data.familyBundleData?.errorType === 'members'
        ) {
          console.log('[AbroadTicketMain COMPLETED_SUCCESSFUL] → navigating to self-care (FBM01 or regular customer)');
          props.context.navigateTo(props?.iContent?.linkForAbroadSelfCare.value?.url);
          break;
        } else {
          return (
            <CompletedSuccessfulComponent
              context={props.context}
              iContent={props?.iContent}
              businessOrPrivate={businessOrPrivate}
              phone={phoneObj}
            />
          );
        }
      case saleActiveStep.COMPLETED_WITH_ERROR:
        return (
          <CompletedWithErrorComponent
            context={props.context}
            LinkForAbroadSelfCare={props.iContent.linkForAbroadSelfCare}
            businessOrPrivate={businessOrPrivate}
          />
        );

      default:
        return null;
    }
  }

  //POPUPS
  const currentPopup = useMemo(() => {
    if (props.data.isShowPopup && allowedPopupsReasons.includes(props.data.popupReason)) {
      if (props.data.popupReason == popupReasonEnum.OTP_RESULT && !getOtpPopupStatus()) {
        props.closeModal();
        props.saveToHistory();
        return;
      }
      return getCurrentPopupContent();
    }
  }, [props.data.isShowPopup, props.data.popupReason]);

  function getOtpPopupStatus() {
    if (
      (props.data.epiStyleInitializationData.businessIndividualLobby && !props.data.businessIndividualData.popupData) ||
      (!props.data.epiStyleInitializationData.businessIndividualLobby &&
        !props.data.otpData.otpPopupData &&
        !props.data?.otpDataChildren?.otpPopupData)
    ) {
      return false;
    }
    return true;
  }

  function getCurrentPopupContent() {
    let popup;

    switch (props.data.popupReason) {
      case popupReasonEnum.OTP_RESULT:
        let popupData;
        if (props.data.epiStyleInitializationData.businessIndividualLobby) {
          popupData = props.data.businessIndividualData.popupData;
        } else {
          popupData = !props.data.otpData?.isFamilyProcess ? props.data.otpData.otpPopupData : props.data.otpDataChildren.otpPopupData;
        }
        popup = <OtpValidationResultPopupConstructor popupData={popupData} context={props.context} />;
        break;

      case popupReasonEnum.CHANGE_PACKAGE_START_DAY:
        popup = (
          <ChangeStartPackageDatePopup
            startDate={props.data.dates.datePickerStartJSFormat}
            startDateParent={props.data.otpData?.startDateParentJs}
            title={'עדכון תאריך התחלה'}
            action={(startDate) => formatAndSave(startDate)}
            isPortrait={props.data.isPortrait}
            isSmallResolution={props.data.isSmallResolution}
            buttonText={'עדכון'}
            description={props.data.otpData?.isFamilyProcess ? `החבילה יכולה להתחיל עד שבעה ימים מהיום בו מתחילה החבילה הראשית` : ``}
            isFromFamily={props.data.otpData?.isFamilyProcess ? true : false}
          />
        );
        break;
      case popupReasonEnum.DATA_USAGE_IS_BLOCKED:
        popup = <DataUsageIsBlockedPopupComponent businessOrPrivate={businessOrPrivate} />;
        break;
      case popupReasonEnum.ACCOUNT_SEGMENT_MATCH_SOC:
        popup = <AccountSegmentMatchSocPopupComponent context={props.context} />;
        break;
      case popupReasonEnum.DISPLAY_INFO_FAMILY:
        popup =  <InfoFamilyPackagePopup abroadPackageClient={props.data.selectedAbroadPackage?.familyPackageInfo} instructionFamilyMemberPackage={props.iContent.instructionFamilyMemberPackage} />
        break;
        case popupReasonEnum.DISPLAY_INFO_FAMILY_BUNDLE:
          popup = <FamilyBundleInfoPopup closePopUp={props.closeModal} packageData={props.data.selectedAbroadPackage} info={props.iContent.familyBundleInfo.value} />;
          break;
      case popupReasonEnum.STATE_SUPPORTED:
        popup = <AbroadStateInclude stateInclude={props.data.selectedAbroadPackage?.countrySupportedDictionary} fromFamily={true} />;
        break;
      case popupReasonEnum.ENABLE_INDEPENDENT_PURCHASE:
        popup = <IndependentPurchasePermissionPopUp props={props} />;
        break;
      case popupReasonEnum.BUY_WITH_ORG_TICKET:
        popup = <InterestedToBuyFromOrgPopup setBuyInSplit={setToBuyInSplit} />;
        break;
      case popupReasonEnum.RESTRICTED_CODE_REQUIRED:
        popup = <RestrictedCodePopup submitValidateCustomerType={submitValidateCustomerType} />;
        break;
      case popupReasonEnum.CAP_SOC:
        popup = <CapSocPopup />;
        break;
      case popupReasonEnum.CAP_SOC_REMOVE_PROCESSING:
        popup = <CapSocRemoveProcessPopup />;
        break;
      case popupReasonEnum.SELECT_FAMILY_MEMBERS:
        // Get cellular subscribers from selfcare data
        const cellularSubscribers = props.selfcarePage?.subscribersByProduct?.Cellular || [];
        const availableMembersFromSelfcare = cellularSubscribers.map(subscriber => ({
          id: subscriber.productSubscriberNo,
          phone: subscriber.productSubscriberNo,
          name: `${subscriber.productFirstName} ${subscriber.productLastName}`.trim(),
          ...subscriber,
        }));

        popup = (
          <SelectFamilyMembersPopup
            availableMembers={availableMembersFromSelfcare}
            selectedMembers={props.data.familyBundleData.selectedMembers}
            flightManager={props.data.familyBundleData.flightManager}
            multipleBans={props.data.familyBundleData.multipleBans}
            selectedBan={props.data.familyBundleData.selectedBan}
            showTooltip={props.data.familyBundleData.showFlightManagerTooltip}
            onFlightManagerHasFamilySoc={() => {
              dispatch(setFamilyBundleErrorType('hasFamilySoc'));
              props.closeModal();
              setTimeout(() => props.openModal(popupReasonEnum.FAMILY_BUNDLE_HAS_SOC), 50);
            }}
            onClose={() => {
              dispatch({ type: 'cellcomAbroad/closeMemberSelectionPopup' });
              props.closeModal();
            }}
            onContinue={(selectedMembers) => {
              dispatch({ type: 'cellcomAbroad/setSelectedMembers', payload: selectedMembers });
              dispatch({ type: 'cellcomAbroad/closeMemberSelectionPopup' });
              props.closeModal();
              // Clear error message when members are selected
              const event = new CustomEvent('clearFamilyBundleError');
              window.dispatchEvent(event);
              // TODO: Proceed to purchase or next step
            }}
            onBanSelect={(ban) => {
              dispatch({ type: 'cellcomAbroad/setSelectedBan', payload: ban });
            }}
          />
        );
        break;
      case popupReasonEnum.NO_MEMBERS_SELECTED:
        // Check if there are more subscribers available (excluding flight manager)
        const cellularSubscribersForCheck = props.selfcarePage?.subscribersByProduct?.Cellular || [];
        const flightManagerPhone = props.data.familyBundleData.flightManager?.phone;
        const hasMoreSubscribers = cellularSubscribersForCheck.filter(
          sub => sub.productSubscriberNo !== flightManagerPhone
        ).length > 0;

        popup = (
          <NoMembersSelectedPopup
            hasMoreSubscribers={hasMoreSubscribers}
            onAddMembers={() => {
              props.openModal(popupReasonEnum.SELECT_FAMILY_MEMBERS);
            }}
            onContinue={() => {
              props.closeModal();
              // Set flag to bypass member validation and trigger submit
              dispatch({ type: 'cellcomAbroad/setBypassMemberValidation', payload: true });
              // Trigger form submission after modal closes
              setTimeout(() => {
                const submitButton = document.querySelector('.step-button-container button');
                if (submitButton) {
                  submitButton.click();
                }
              }, 100);
            }}
            closePopUp={() => {
              props.closeModal();
            }}
            onChooseAnotherPackage={() => {
              props.closeModal();
              props.returnToLobby({ activeTab: lobbyTabsEnum.PRIVATE });
              props.context.navigateTo(props.data.epiStyleInitializationData.currentLobbyPath);
            }}
          />
        );
        break;
      case popupReasonEnum.FAMILY_BUNDLE_HAS_SOC:
        popup = (
          <FamilyBundleErrorPopup
            errorType="hasFamilySoc"
            onSelectAnotherPackage={() => {
              props.closeModal();
              props.returnToLobby({ activeTab: lobbyTabsEnum.PRIVATE });
              props.context.navigateTo(props.data.epiStyleInitializationData.currentLobbyPath);
            }}
            onClose={() => props.closeModal()}
          />
        );
        break;
      case popupReasonEnum.FAMILY_BUNDLE_FLIGHT_MANAGER_ERROR:
      case popupReasonEnum.FAMILY_BUNDLE_FLIGHT_MEMBERS_ERROR:
      case popupReasonEnum.FAMILY_BUNDLE_CELLULAR_DATA_OFF:
        {
          const isFlightManagerCase = props.data.popupReason === popupReasonEnum.FAMILY_BUNDLE_FLIGHT_MANAGER_ERROR;
          const isCellularOffCase = props.data.popupReason === popupReasonEnum.FAMILY_BUNDLE_CELLULAR_DATA_OFF;
          const fb = props.data.familyBundleData || {};
          const errorTypeProp = fb.errorType || (isFlightManagerCase ? 'flightManager' : isCellularOffCase ? 'cellularOff' : 'members');
          popup = (
            <FamilyBundleErrorPopup
              errorType={errorTypeProp}
              flightManager={fb.flightManager}
              failedMembers={fb.failedMembers}
              onSelectDifferentFlightManager={() => {
                props.setFlightManager(null);
                console.log('[AbroadTicketMain] Flight manager reset to null');
                props.closeModal();
              }}
              onContinueWithRest={() => {
                props.closeModal();
              }}
              onCancelPackage={() => {
                props.closeModal();
              }}
              onClose={() => {
                props.closeModal();
              }}
              onTurnOnCellularData={(members) => {
                props.closeModal();
              }}
            />
          );
        }
        break;
    }
    return popup;
  }

  const closeModal = () => {
    if (props.data.otpData.otpPopupData?.id == 'isPrivateAccount' && !props.authentication?.loginData?.isFullAuthenticated) {
      logout();
    } else if (props.data.otpData?.isFamilyProcess && props.data.otpDataChildren?.otpPopupData?.id == 'defaultPackageExists') {
      props.closeModal({ isDefaultSocFromFamily: true });
      return;
    } else if (
      (!props.data.otpData.validatedCostumerData?.accountTypeIsValid?.item2 &&
        props.data.otpData.validatedCostumerData?.accountTypeIsValid?.item1 == 'CellcomWorker') ||
      props.data.otpData?.otpPopupData?.id == 'isBusinessAccount'
    ) {
      if (props.data.otpData?.otpPopupData?.id == 'isBusinessAccount') {
        if (props.data.startedFromPackage) {
          gtag4({
            event: 'CellcomAbroad_Step8_BusinessPackagesButton',
            button: 'עבור_לחבילות_עסקיות',
            step: '8',
            action: 'BusinessPackagesButton',
            process_type: 'private',
            funnel_name: '3 - Package',
          });
        } else {
          gtag4({
            event: 'CellcomAbroad_Step11_BusinessPackagesButton',
            button: 'עבור_לחבילות_עסקיות',
            step: '11',
            action: 'BusinessPackagesButton',
            process_type: 'private',
            funnel_name: '2 - SearchArea',
          });
        }
      } else {
        if (props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE_FROM_PACKAGE.eventType,
            'סגירה',
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE.category,
            gaParams.ABROAD_TICKET_OTP_VALIDATION_IS_CELLCOM_WORKER_BUTTON_ACTION_PRIVATE.eventType,
            'סגירה',
          );
        }
      }

      props.setSaleActiveStep(saleActiveStep.LOADER);
      props.context.navigateTo(props.data.epiStyleInitializationData.currentLobbyPath);
      props.returnToLobby({ activeTab: lobbyTabsEnum.BUSINESSACCOUNT });
    } else if (props.data.popupReason == popupReasonEnum.ACCOUNT_SEGMENT_MATCH_SOC && props.data.saleActiveStep == saleActiveStep.LOADER) {
      props.setSaleActiveStep(saleActiveStep.TICKET);
    } else if (
      props.data.otpData.otpPopupData?.id == 'separatedNoShadowSocTicket' ||
      props.data.otpData.otpPopupData?.id == 'separatedNoShadowSoc' ||
      props.data.otpData.otpPopupData?.id == 'separatedNoShadowSocCatalogBusinessInd' ||
      props.data.otpData.otpPopupData?.id == 'abroadIsClosedForAccountSeparatedBank' ||
      props.data.otpData.otpPopupData?.id == 'abroadIsClosedForAccountSeparatedByUse' ||
      props.data.otpData.otpPopupData?.id == 'separatedGeneralError'
    ) {
      props.returnToLobby({ activeTab: lobbyTabsEnum.BUSINESSACCOUNT });
    }

    props.closeModal();
  };

  const formatAndSave = (startDate) => {
    switch (businessOrPrivate) {
      case customerTypeEnum.PRIVATE:
        if (props.data.startedFromPackage) {
          gaEvent(
            gaParams.ABROAD_TICKET_START_DATE_IS_CHANGED_PRIVATE_FROM_PACKAGE.category,
            gaParams.ABROAD_TICKET_START_DATE_IS_CHANGED_PRIVATE_FROM_PACKAGE.eventType,
            gaParams.ABROAD_TICKET_START_DATE_IS_CHANGED_PRIVATE_FROM_PACKAGE.eventParams,
          );
        } else {
          gaEvent(
            gaParams.ABROAD_TICKET_START_DATE_IS_CHANGED_PRIVATE.category,
            gaParams.ABROAD_TICKET_START_DATE_IS_CHANGED_PRIVATE.eventType,
            gaParams.ABROAD_TICKET_START_DATE_IS_CHANGED_PRIVATE.eventParams,
          );
        }

        break;
      case customerTypeEnum.BUSINESS:
        break;
      default:
        break;
    }

    let dates = formatDatesToDifferentFormats(startDate);
    props.saveSelectedStartDate({ selectedStartDate: dates.formattedUI, datePickerStartJSFormat: dates.formattedISOS });
    props.closeModal();
  };

  const gaReportOnLoading = () => {
    let params = `${props.data.selectedAbroadPackage?.socCode}, ${props.data.selectedAbroadPackage?.price} `;

    gaOnLoadTicket(
      businessOrPrivate,
      props.data?.otpData?.isFamilyProcess,
      props.data.startedFromPackage,
      props?.data?.comingFromPackageManager,
      props.data.epiStyleInitializationData.businessIndividualLobby,
      params,
    );
  };

  function logout() {
    //props.resetAuth();
    props.resetLoginData();
    props.removeOtpData();
    props.resetFamilyBundleData();
    props.saveToHistory();
  }

  return (
    <>
      <Container
        className={`${isMobile ? 'isMobile' : ''} abroad-ticket-container ${props.data.saleActiveStep == saleActiveStep.COMPLETED_WITH_ERROR ? 'completed-with-error' : ''
          } ${props.data.saleActiveStep == saleActiveStep.LOADER ? ' loader-page' : ''}`}>
        {renderedStep()}

        <PopUp
          className={props.data.popupReason}
          showPopUp={props.data.isShowPopup && allowedPopupsReasons.includes(props.data.popupReason)}
          onClose={() => closeModal()}>
          {currentPopup}
        </PopUp>
      </Container>
    </>
  );
}
const mapStateToProps = (state) => ({
  data: state.cellcomAbroad,
  PaymentCG: state.PaymentCG,
  portalsBlock: state.portalsBlock,
  authentication: state.authentication,
  organizationType: state.welcomeBlock.organizationState?.organizationType,
  blockId: state.selfcarePage?.worlds?.abroad?.abroadLobbyBlockId,
  selfcarePage: state.selfcarePage,
  selectedSubscriberPhone: state.selfcarePage?.selectedSubscriber?.productSubscriberNo,
});

const mapDispatchToProps = {
  setLoading,
  removeOtpData,
  closeModal,
  setOtpPopupData,
  abroadRetrieveCustomerData,
  validateCustomerType,
  validateCustomerFamilyType,
  openModal,
  abroadRemoveAndAddSoc,
  abroadRemoveAndAddSocFamily,
  setSelfcareSubscriber,
  returnToLobby,
  setSaleActiveStep,
  saveNotSupportedCountries,
  saveToHistory,
  saveSelectedStartDate,
  setShadowProcessStage,
  setSelectedAbroadPackage,
  eCommerceReportBuyRegularPackage,
  eCommerceReportBuyFamilyPackage,
  PlantShadowMemo,
  PlantMemoBeforePackagePurchase,
  abroadRetrieveCustomerDataNoEffect,
  abroadRemoveAndAddSocBusinessIndividual,
  resetAuth,
  resetLoginData,
  setSaleOtpStep,
  setReadyToPurchaseForBusinessIndividualAndSetAllowIndependentFuturePurchases,
  setReadyToPurchase,
  setBuyPackageInSplit,
  setSwitchingAccount,
  displayRestrictedCodePopup,
  resetFamilyBundleData,
  clearPurchasedFamilyBundleData,
  resetCoupon,
  setFlightManager,
};

export default connect(mapStateToProps, mapDispatchToProps)(AbroadTicketMain);
